import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import Table from "defaultComponents/Tables/Table";
import * as S from './style'
import { useNavigate } from "react-router-dom";
import { TokenContext } from "context/TokenContext";
import { useContext } from "react";
import Tooltip from "@mui/material/Tooltip";
import VuiAvatar from "components/VuiAvatar";
import VuiProgress from "components/VuiProgress";
import { Grid } from "@mui/material";
import { IoEllipsisVertical, IoAlertCircleOutline } from "react-icons/io5";
import ButtonCustom from "components/ButtonCustom/ButtonCustom";
import Modal from "components/Modal/Modal";
import showToast from "components/Toast/Toast";
import moment from 'moment';
import 'moment/locale/pt-br';
import { editBriefingProject } from "utils/requests/project";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { capitalize } from "utils/utils";

const MarketingProjectsTable = ({ projects, showFinished, routing, refetch, isMarketing }) => {
  moment.locale("pt-br");
  const [openDeleteMenu, setOpenDeleteMenu] = useState([]);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [openBudgetActionModal, setOpenBudgetActionModal] = useState(false);
  const [budgetActionType, setBudgetActionType] = useState('');
  const [openActivationModal, setOpenActivationModal] = useState(false);
  const [openFinishProjectModal, setOpenFinishProjectModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState();
  const [newProjectType, setNewProjectType] = useState('');

  const avatars = (members) => {
    return (
      members.map(([image, name]) => (
        <Tooltip key={name} title={name} placeholder="bottom">
          <VuiAvatar
            src={image}
            alt="name"
            size="sm"
            sx={{
              border: ({ borders: { borderWidth }, palette: { dark } }) =>
                `${borderWidth[2]} solid ${dark.focus}`,
              cursor: "pointer",
              position: "relative",

              "&:not(:first-of-type)": {
                ml: -1.25,
              },

              "&:hover, &:focus": {
                zIndex: "10",
              },
            }}
          />
        </Tooltip>
      ))
    );
  };

  const { decodedToken } = useContext(TokenContext);

  const role = decodedToken?.type;

  const navigate = useNavigate();

  const navigateObject = {
    ADMINISTRATOR: `/marketing/projetos/`,
  };

  const toggleOpenMenu = (index) => {
    const updatedMenu = [...openDeleteMenu];
    updatedMenu[index] = !updatedMenu[index];
    setOpenDeleteMenu(updatedMenu);
  };

  const handleActivationModal = (project) => {
    setOpenActivationModal(true);
    setSelectedProject(project);
  };

  const cancelActivation = () => {
    setOpenActivationModal(false);
    setSelectedProject();
  };

  const handleBudgetActionModal = (project, actionType) => {
    setSelectedProject(project);
    setBudgetActionType(actionType);
    setOpenBudgetActionModal(true);
  };

  const cancelBudgetAction = () => {
    setOpenBudgetActionModal(false);
    setSelectedProject();
    setBudgetActionType('');
  };

  const handleDetailsModal = (project) => {
    setOpenDetailsModal(true);
    setSelectedProject(project);
  };

  const closeDetailsModal = () => {
    setOpenDetailsModal(false);
    setSelectedProject();
  };

  const handleFinishProjectModal = (project) => {
    setSelectedProject(project);
    setOpenFinishProjectModal(true);
  };

  const cancelFinishProject = () => {
    setOpenFinishProjectModal(false);
    setSelectedProject();
  };

  const handleActivation = async () => {
    if (newProjectType) {
      await editBriefingProject(selectedProject?.id, { status: 'ONGOING', type: newProjectType }).then((res) => {
        if (!res?.message) {
          showToast("Projeto iniciado com sucesso!", "success");
          setSelectedProject();
          setTimeout(
            () => navigate(`${navigateObject[role]}${selectedProject?.id}`, { state: { type: selectedProject?.type } }), 2000
          );
          return
        }
        showToast("Falha ao iniciar projeto", "error");
      })
      return
    };
    showToast("Nenhum tipo de projeto selecionado!", "error");
  };

  const handleBudgetAction = async () => {
    const successMessages = {
      'payment_approval': "Pagamento aprovado com sucesso",
      'enable_finalization': "Finalização habilitada com sucesso"
    };

    const errorMessages = {
      'payment_approval': "Falha ao aprovar pagamento",
      'enable_finalization': "Falha ao habilitar finalização"
    };

    await editBriefingProject(selectedProject?.id, { budget: { status: "PAGO" } }).then((res) => {
      if (!res.message) {
        showToast(successMessages[budgetActionType], "success");
        refetch();
        setOpenBudgetActionModal(false);
        return;
      }
      showToast(errorMessages[budgetActionType], "error");
    });
  };

  const handleProjectFinalization = async () => {
    await editBriefingProject(selectedProject?.id, { status: "ENDED", endDateMs: moment().valueOf() }).then(
      (res) => {
        if (!res?.message) {
          showToast("Projeto finalizado com sucesso!", "success");
          setOpenFinishProjectModal(false);
          refetch();
          return;
        }
        showToast("Falha ao finalizar projeto", "error");
      }
    );
  };

  const handleStatusChange = (event) => {
    setNewProjectType(event.target.value);
  };

  const statusTranslation = {
    LEADS: "Leads 🔥",
    RELATIONSHIP: "Relacionamento 🎯",
    FOLLOW_UP: "FUP - Leads 🆙",
    NEGOTIATION: "Em Negociação 💰",
    CLOSED_CONTRACT: "Contrato Fechado 🤝",
    REJECTED: "Rejeitado",
    ONGOING: "Em andamento",
    ENDED: "Finalizado",
  };

  return (
    <Card
      sx={{
        height: "100% !important",
      }}
    >
      <VuiBox
        sx={{
          paddingBottom: '10px',
          "& th": {
            borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
              `${borderWidth[1]} solid ${grey[700]}`,
          },
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                `${borderWidth[1]} solid ${grey[700]}`,
            },
          },
          paddingBottom: '40px'
        }}
        onClick={() => openDeleteMenu.includes(true) ? setOpenDeleteMenu(openDeleteMenu.map((bool) => false)) : null}
      >
        <Table
          columns={
            isMarketing
              ?
              [
                { name: "empresa", align: "left" },
                { name: "influencers", align: "left" },
                { name: "tipo", align: "left" },
                { name: "projeto", align: "center" },
                { name: "realização", align: "center" },
              ]
              :
              [
                { name: "empresa", align: "left" },
                { name: "influencers", align: "left" },
                { name: "tipo", align: "left" },
                { name: "projeto", align: "center" },
                { name: "budget", align: "center" },
                { name: "realização", align: "center" },
              ]
          }
          rows={
            projects && projects?.map((project, index) => {
              return {
                empresa: (
                  <VuiBox display="flex" alignItems="center" key={project?.id}>
                    <VuiTypography pl="16px" color="white" variant="button" fontWeight="medium">
                      {project?.leadsRelated?.businessName ?? ""}
                    </VuiTypography>
                  </VuiBox>
                ),
                influencers: (
                  <VuiBox display="flex" py={1}>
                    {avatars(project.influencers.map((influencer) => [influencer.avatar, influencer.name]))}
                  </VuiBox>
                ),
                tipo: (
                  <VuiTypography variant="button" color="white" fontWeight="bold">
                    {project?.type ?? ""}
                  </VuiTypography>
                ),
                projeto: (
                  <VuiTypography variant="button" color="white" fontWeight="bold">
                    {project?.title ?? ""}
                  </VuiTypography>
                ),
                budget: (
                  <VuiTypography variant="button" color="white" fontWeight="bold">
                    R${project?.budget?.value > 0 ? ((project?.budget?.value / 100).toFixed(2)).toLocaleString("pt-BR") : 0}
                  </VuiTypography>
                ),
                realização: (
                  <S.ProgressGrid container justifyContent='space-around'>
                    <Grid container item xs={8} xl={10} justifyContent='center'>
                      <VuiBox width="8rem" textAlign="center" sx={{ width: "80%" }} >
                        <VuiTypography color="white" variant="button" fontWeight="bold">
                          {project?.progress ? Math.round(Number(project?.progress)) : 0}%
                        </VuiTypography>
                        <VuiProgress value={project?.progress ?? 0} color="viuzz" label={false} sx={{ background: "rgba(96, 96, 96, 0.5)" }} />
                      </VuiBox>
                    </Grid>
                    <Grid container item xs={2} xl={1} onClick={() => toggleOpenMenu(index)}>
                      <IoEllipsisVertical size='20px' style={{ cursor: "pointer" }} />
                    </Grid>
                    {openDeleteMenu[index] &&
                      <S.OptionsContainer container justifyContent='flex-end'>
                        <S.OptionsGrid display='flex' flexDirection='column'>
                          <p onClick={() => navigate(`${navigateObject[role]}${project?.id}`, { state: { type: project?.type } })}>Ir para Projeto</p>
                          {project?.teamTargeted === "EXTERNAL" &&
                            <>
                              <S.Divider />
                              <p onClick={() => handleDetailsModal(project)}>
                                Ver Detalhes
                              </p>
                            </>
                          }
                          {(project?.status === "CLOSED_CONTRACT" || project?.status === "ONGOING") &&
                            project?.budget?.status === "PENDENTE" &&
                            <>
                              <S.Divider />
                              <p onClick={() => handleBudgetActionModal(project, 'payment_approval')}>
                                Aprovar Pagamento
                              </p>
                            </>
                          }
                          {project?.teamTargeted === "INTERNAL" &&
                            project?.budget?.status === "PENDENTE" &&
                            <>
                              <S.Divider />
                              <p onClick={() => handleBudgetActionModal(project, 'enable_finalization')}>
                                Habilitar Finalização
                              </p>
                            </>
                          }
                          {project?.status === "CLOSED_CONTRACT" &&
                            <>
                              <S.Divider />
                              <p onClick={() => handleActivationModal(project)}>
                                Iniciar projeto
                              </p>
                            </>
                          }
                          {project?.canBeEnded && project?.status === "ONGOING" &&
                            <>
                              <S.Divider />
                              <p onClick={() => handleFinishProjectModal(project)}>
                                Finalizar projeto
                              </p>
                            </>
                          }
                        </S.OptionsGrid>
                      </S.OptionsContainer>
                    }
                  </S.ProgressGrid>
                ),
              }
            },)
          }
        />
      </VuiBox>
      <Modal size="md" open={openDetailsModal} onClose={() => closeDetailsModal()}>
        <Grid container flexDirection="column" gap="5px">
          <p style={{ fontSize: "22px" }}>{selectedProject?.title}</p>
          <p style={{ fontSize: "18px" }}>Status: {statusTranslation[selectedProject?.status]}</p>
        </Grid>
        <Grid container flexDirection="column" gap="20px" mt="10px">
          <Grid container justifyContent="space-between">
            <Grid item xs={12} md={5.85} xl={5.85}>
              <p>Empresa:</p>
              <p>{selectedProject?.leadsRelated?.businessName ?? ""}</p>
            </Grid>
            <Grid item xs={12} md={5.85} xl={5.85}>
              <p>Valor do Negócio:</p>
              <p>
                R${" "}
                {selectedProject?.budget?.value > 0
                  ? Number((selectedProject?.budget?.value / 100).toFixed(2)).toLocaleString(
                      "pt-BR",
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    )
                  : 0}
              </p>
            </Grid>
          </Grid>
          <Grid container justifyContent="space-between">
            <Grid item xs={12} md={5.85} xl={5.85}>
              <p>Data de Fechamento:</p>
              <p>
                {selectedProject?.budget?.dealCloseDate
                  ? moment(selectedProject?.budget?.dealCloseDate).format("DD/MM/YYYY HH:mm")
                  : ""}
              </p>
            </Grid>
            <Grid item xs={12} md={5.85} xl={5.85}>
              <p>Data de Pagamento:</p>
              <p>
                {selectedProject?.budget?.paymentDate
                  ? moment(selectedProject?.budget?.paymentDate).format("DD/MM/YYYY HH:mm")
                  : ""}
              </p>
            </Grid>
          </Grid>
          <Grid container justifyContent="space-between">
            <Grid item xs={12} md={5.85} xl={5.85}>
              <p>Influencers:</p>
              <p>
                {selectedProject?.influencers &&
                  selectedProject?.influencers?.map((influencer) => influencer.name).join(", ")}
              </p>
            </Grid>
            <Grid item xs={12} md={5.85} xl={5.85}>
              <p>Status de Pagamento:</p>
              <p>
                {selectedProject?.budget?.status
                  ? capitalize(selectedProject?.budget?.status?.toLowerCase())
                  : ""}
              </p>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <p>Descrição:</p>
            <p>{selectedProject?.description}</p>
          </Grid>
          <Grid container justifyContent="space-between">
            <Grid item xs={12} md={5.85} xl={5.85}>
              <p>Data de Criação:</p>
              <p>
                {selectedProject?.createdAt
                  ? moment(selectedProject?.createdAt).format("DD/MM/YYYY HH:mm")
                  : ""}
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
      <Modal size='sm' open={openActivationModal} onClose={() => cancelActivation()}>
        <Grid container flexDirection='column' gap='20px'>
          {/* <p style={{ fontSize: "24px" }}>Qual o tipo de projeto que vamos iniciar?</p> */}
          <p style={{ fontSize: "18px" }}>Qual o tipo de projeto que vamos iniciar?</p>
          <Grid container flexDirection='column'>
            <RadioGroup
              value={newProjectType}
              onChange={handleStatusChange}
            >
              <Grid container flexDirection='column'>
                <FormControlLabel value="CAMPANHA" control={<Radio />} label="Campanha" />
                <FormControlLabel value="PALCO" control={<Radio />} label="Palco" />
                <FormControlLabel value="EVENTOS" control={<Radio />} label="Eventos" />
                <FormControlLabel value="AUDIOVISUAL" control={<Radio />} label="Audio Visual" />
                <FormControlLabel value="LIVRO" control={<Radio />} label="Livro" />
              </Grid>
            </RadioGroup>
          </Grid>
          <Grid container gap='15px' justifyContent='flex-end'>
            <ButtonCustom
              label='Iniciar Projeto'
              onClick={() => handleActivation()}
              sx={{
                width: '150px',
                fontSize: '14px',
                height: '40px !important',
                fontWeight: '500'
              }}
            />
          </Grid>
        </Grid>
      </Modal>
      <Modal size="sm" open={openBudgetActionModal} onClose={() => cancelBudgetAction()}>
        <Grid container flexDirection="column" gap="20px">
          <p style={{ fontSize: "24px" }}>
            {budgetActionType === 'payment_approval' ? 'Aprovar pagamento' : 'Habilitar Finalização'}
          </p>
          <p style={{ fontSize: "18px" }}>
            {budgetActionType === 'payment_approval' 
              ? `Deseja aprovar o pagamento do projeto ${selectedProject?.title}?`
              : `Deseja habilitar a finalização do projeto ${selectedProject?.title}?`
            }
          </p>
          <Grid container gap="15px" justifyContent="center">
            <Grid item lg={3}>
              <ButtonCustom
                label="Cancelar"
                onClick={() => cancelBudgetAction()}
                sx={{ background: "linear-gradient(180deg, #818181 0%, #2a2020 155.15%)" }}
              />
            </Grid>
            <Grid item lg={3}>
              <ButtonCustom label="Confirmar" onClick={() => handleBudgetAction()} />
            </Grid>
          </Grid>
        </Grid>
      </Modal>
      <Modal
        size="md"
        open={openFinishProjectModal}
        onClose={() => cancelFinishProject()}
      >
        <Grid container flexDirection="column" gap="20px">
          <p style={{ fontSize: "24px" }}>Tem certeza que deseja finalizar este projeto?</p>
          <Grid container gap="15px" justifyContent="center">
            <Grid item xs={8} lg={6} mt="40px">
              <ButtonCustom
                label="Autorizar Finalização"
                onClick={handleProjectFinalization}
                sx={{
                  background: "linear-gradient(180deg, #5ACC93 0%, #0E1B05 155.15%)",
                  fontSize: "16px",
                }}
              />
            </Grid>
          </Grid>
          <S.AlertGrid container gap="5px" mt="15px">
            <IoAlertCircleOutline size="24px" color="red" style={{ alignSelf: "center" }} />
            <p className="bold">Lembrete: </p>
            <p>Você não poderá voltar atrás.</p>
          </S.AlertGrid>
        </Grid>
      </Modal>
    </Card >
  );
}

export default MarketingProjectsTable;
